import React, { Component } from 'react';
import { withRouter } from 'react-router';
import HubspotForm from '../hubspotForm';
import { track } from '../../../track';
import style from './style.scss';

class NoGACSignup extends Component {
  componentDidMount() {
    track('signupforGG', {
      step: '/no-gac',
    });
  }

  render() {
    return (
      <div className={style.signupContainer}>
        <div className={style.signupForm}>
          <HubspotForm formId='fc210f9e-0bf1-4be9-a7d3-8e8c1040e340' />
        </div>
      </div>
    );
  }
}

export default withRouter(NoGACSignup);



/** WEBPACK FOOTER **
 ** ./src/app/components/noGACSignup/index.jsx
 **/